import React, { useEffect, useState } from "react";
import axios from "axios";
import { NotificationAlert } from "../../../../../components/Notification/Notification";
import {
  generateGptCreditRequest,
  updateUserGptCredit,
} from "../../../../../Assets/api/api";
import { toast } from "react-toastify";
import { getUserLanguage } from "../../../../../utils/i18n";
import i18n from "../../../../../helper/i18n";

const FEEDBACK_TYPES_OPTIONS = [
  {
    label: "Text",
    value: "TEXT",
  },
  {
    label: "Poll",
    value: "POLL",
  },
];

const API_URL = process.env.REACT_APP_EP_URL;

const useMagicBar = ({
  responseHandler,
  type,
  isMixMode,
  FEEDBACK_TYPES,
  user,
  setUser,
  extractSentiment,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [language, setLanguage] = useState("English");

  const [title, setTitle] = useState("");
  const [feedbackType, setFeedbackType] = useState(
    type?.toLowerCase() ?? "text"
  );
  const [noOfFeedback, setNoOfFeedback] = useState(5);
  const [noOfOption, setNoOfOption] = useState(5);
  const [isOpenValidationDialog, setIsOpenValidationDialog] = useState(false);
  const [prompList, setPrompList] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchGptPrompt();
  }, []);

  const buttonClickHandler = () => {
    setIsDialogOpen(true);

    setTitle("");
    setNoOfFeedback(5);
    setNoOfOption(5);
    setLanguage("English");
  };

  const closeDialogHandler = () => {
    setIsDialogOpen(false);
    setError("");
  };

  const languages = [
    "English",
    "Español",
    "Português",
    "Français",
    "Deutsch",
    "हिन्दी",
  ];

  const feedbackTypes = FEEDBACK_TYPES_OPTIONS.map((item) => item.label);

  const noOfOptions = Array(5)
    .fill(1)
    .map((_, i) => i + 1);

  const noOfFeedbackQuestions = Array(20)
    .fill(1)
    .map((_, i) => i + 1);

  const isNotMultiItem =
    [FEEDBACK_TYPES.audio, FEEDBACK_TYPES.video].includes(type) ||
    (FEEDBACK_TYPES.any === type && !isMixMode);

  const handleGenerateGptCreditRequest = async () => {
    try {
      setIsLoading(true);
      const payload = {
        credit: 5,
        TeacherEmailID: user.mail,
        TeacherName: user.name,
        role: user.role,
        status: "pending",
      };
      await generateGptCreditRequest(payload, user.slug, user.accessToken);
      setUser((prev) => ({
        ...prev,
        isRequestedForGptCredit: true,
      }));
      setIsLoading(false);
      toast.success("Gpt Credit request generated successfully!");
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  const handleUpdateUserCredit = async (key) => {
    try {
      let creditsToDeduct = 1;
      if (key) {
        const { data } = await axios(
          `${API_URL}/api/credit-extention/get-credit-extention-data`
        );
        const { result } = data;
        const matchedItem = result.find(
          (item) => Number(item.comparison_key) === key
        );
        creditsToDeduct = matchedItem.credits ? matchedItem.credits : 1;
      }

      const payload = {
        credit: user.credit - creditsToDeduct,
        mail: user.mail,
        role: user.role,
      };
      await updateUserGptCredit(payload, user.slug, user.accessToken);
      setUser((prev) => ({
        ...prev,
        credit: user.credit - creditsToDeduct,
      }));
    } catch (error) {
      console.log("error from handleUpdateUserCredit", error.message);
    }
  };

  const getKey = () => {
    if (!extractSentiment) {
      if (
        type === "AUDIO" ||
        type === "VIDEO" ||
        type === "POLL" ||
        (type === "TEXT" && noOfFeedback <= 5)
      ) {
        return 101; // Case 1
      } else if (type === "POLL" || (type === "TEXT" && noOfFeedback > 5)) {
        return 103; // Case 4
      }
    } else {
      if (type === "AUDIO" || type === "VIDEO") {
        return 102; // Case 2
      } else if (type === "POLL" || (type === "TEXT" && noOfFeedback <= 5)) {
        return 103; // Case 3
      } else if (type === "POLL" || (type === "TEXT" && noOfFeedback > 5)) {
        return 105; // Case 5
      }
    }
  };

  async function generatePrompt(event) {
    const key = getKey();
    // Alert user about adding text
    if (!title) return setIsOpenValidationDialog(true);

    setIsLoading(true);

    const formattedType = type?.toLowerCase();

    console.log(user.slug, key);
    axios
      .post(
        `${API_URL}/api/gpt/generate-content${user.slug}&creditExtentionKey=${key}`,
        {
          type: formattedType,
          isNotMultiItem,
          title,
          questions: ["poll", "text"].includes(formattedType)
            ? noOfFeedback
            : 1,
          options: noOfOption,
          language,
        },
        {
          headers: {
            Authorization: `Bearer ${user.accessToken}`,
          },
        }
      )
      .then(async ({ data }) => {
        if (data?.data) {
          handleUpdateUserCredit(key);
          responseHandler(data.data);
        }
        closeDialogHandler();
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message || err?.message || "Something went wrong"
        );
        // NotificationAlert(
        //   err?.response?.data?.message ||
        //   err?.message ||
        //   "Something went wrong",
        //   "error"
        // );
        console.log("Error:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const getAiGeneratedQuestionsForBookingFeedback = (booking) => {
    const key = getKey();
    setIsLoading(true);
    console.log(user.slug, key);
    axios
      .post(
        `${API_URL}/api/gpt/generate-content${user.slug}&creditExtentionKey=${key}`,
        {
          type: "poll",
          isNotMultiItem: false,
          title: booking?.title || "",
          questions: 10,
          options: 3,
          description: booking?.note || "",
          summary: booking?.summary || "",
          language: getUserLanguage(i18n.language),
        },
        {
          headers: {
            Authorization: `Bearer ${user.accessToken}`,
          },
        }
      )
      .then(async ({ data }) => {
        console.log("data", data);
        setIsLoading(false);
        if (!Array.isArray(data?.data?.questions)) {
          toast.error("Failed to generate questions!");
          console.error("questions is not an array");
          return;
        }
        handleUpdateUserCredit(key);
        responseHandler(data.data);
      })
      .catch((err) => {
        toast.error("Failed to generate questions!");
        setIsLoading(false);
      });
  };

  const fetchGptPrompt = async () => {
    try {
      const { data } = await axios(
        `${API_URL}/api/gpt/get-gpt-prompts${user.slug}&category=feedback`
      );
      setPrompList(data?.data?.length ? data.data : []);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    isDialogOpen,
    buttonClickHandler,
    generatePrompt,
    languages,

    isLoading,
    setIsLoading,
    language,
    setLanguage,

    title,
    setTitle,

    feedbackTypes,
    feedbackType,
    setFeedbackType,
    noOfFeedbackQuestions,
    noOfFeedback,
    setNoOfFeedback,
    closeDialogHandler,
    noOfOption,
    setNoOfOption,
    noOfOptions,
    isNotMultiItem,

    isOpenValidationDialog,
    setIsOpenValidationDialog,
    handleGenerateGptCreditRequest,
    prompList,
    error,
    setError,
    getAiGeneratedQuestionsForBookingFeedback,
  };
};

export default useMagicBar;
